export default __webpack_public_path__ + "static/media/20200618_143142.2b74a5c4.jpg";